import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'packing-material-manage': '包材管理',
 */
const route: AppRouteModule = {
  path: '/packing-material-manage',
  name: 'PackingMaterialManage',
  component: LAYOUT,
  redirect: '/packing-material-manage/packaging-material-bidding-registration',
  meta: {
    icon: 'ic:sharp-my-location',
    title: t('routes.packing-material-manage.packing-material-manage'),
    orderNo: 10000,
    roles: [20222068],
  },
  children: [
    /**
     * 'packaging-material-bidding-registration': '包材招标报名',
     */
    {
      path: 'packaging-material-bidding-registration',
      name: 'PackagingMaterialBiddingRegistration',
      component: () => import('/@/views/packing-material-manage/packaging-material-bidding-registration/index.vue'),
      meta: {
        title: t('routes.packing-material-manage.packaging-material-bidding-registration'),
        roles: [20222069],
      },
    },
    /**
     * 'packaging-material-supplier-quotation': '包材供应商报价',
     */
    {
      path: 'packaging-material-supplier-quotation',
      name: 'PackagingMaterialSupplierQuotation',
      component: () => import('/@/views/packing-material-manage/packaging-material-supplier-quotation/index.vue'),
      meta: {
        title: t('routes.packing-material-manage.packaging-material-supplier-quotation'),
        roles: [20222070],
      },
    },
  ],
};

export default route;
